import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "elan_shop_cart";
const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(read);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, variant, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.variantId === variant.id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: Math.min(next[i].qty + qty, variant.stock || 99) };
        return next;
      }
      return [...prev, {
        productId: product.id,
        variantId: variant.id,
        name: product.name,
        image: (product.images || [])[0] || "",
        unitPrice: product.price,
        size: variant.size || "",
        color: variant.color || "",
        stock: variant.stock || 0,
        qty,
      }];
    });
  };

  const setQty = (variantId, qty) =>
    setItems((prev) => prev.map((x) => (x.variantId === variantId ? { ...x, qty: Math.max(1, Math.min(qty, x.stock || 99)) } : x)));
  const removeItem = (variantId) => setItems((prev) => prev.filter((x) => x.variantId !== variantId));
  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((s, x) => s + x.qty, 0), [items]);
  const subtotal = useMemo(() => Math.round(items.reduce((s, x) => s + x.unitPrice * x.qty, 0) * 100) / 100, [items]);

  return (
    <CartContext.Provider value={{ items, addItem, setQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
